import { render, staticRenderFns } from "./Area.vue?vue&type=template&id=331cfd46&"
import script from "./Area.vue?vue&type=script&lang=js&"
export * from "./Area.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports